import { createCustomAction } from 'typesafe-actions';

import { PcodeAds } from '../../typings/pcode';

import { CampaignInfo, VideoCreativesCollection } from './typings';

export const applyFilter = createCustomAction('@videoCreatives/APPLY_FILTER', type => {
    return (text: string, showTied: boolean) => ({ type, text, showTied });
});
export const loadItems = createCustomAction('@videoCreatives/LOAD_NEXT_ITEMS', type => {
    return (offset: number, filter: string, showTied: boolean) => ({
        type,
        offset,
        filter,
        showTied
    });
});
export const applyFilterSuccess = createCustomAction('@videoCreatives/APPLY_FILTER_SUCCESS', type => {
    return (collection: VideoCreativesCollection) => ({ type, collection });
});
export const loadItemsSuccess = createCustomAction('@videoCreatives/LOAD_ITEMS_SUCCESS', type => {
    return (collection: VideoCreativesCollection) => ({ type, collection });
});
export const getCampaigns = createCustomAction('@videoCreatives/GET_CAMPAIGNS', type => {
    return (id: string) => ({ type, id });
});
export const closeCampaignsList = createCustomAction('@videoCreatives/RESET_CAMPAIGNS');
export const showError = createCustomAction('@videoCreatives/SHOW_ERROR', type => {
    return (message: string) => ({ type, message });
});
export const hideError = createCustomAction('@videoCreatives/HIDE_ERROR');
export const getCampaignsSuccess = createCustomAction('@videoCreatives/GET_CAMPAIGNS_SUCCESS', type => {
    return (items: CampaignInfo[]) => ({ type, items });
});
export const submit = createCustomAction(
    '@videoCreatives/SUBMIT',
    type => (creativesSelect: (ids: number[]) => void) => ({ type, creativesSelect })
);
export const getPreview = createCustomAction('@videoCreatives/GET_PREVIEW', type => {
    return (id: string, videoPreviewData?: PcodeAds) => ({ type, id, videoPreviewData });
});
export const openPreview = createCustomAction('@videoCreatives/OPEN_PREVIEW', type => {
    return (vast: string) => ({ type, vast });
});
export const closePreview = createCustomAction('@videoCreatives/CLOSE_PREVIEW');
export const togglePlaySound = createCustomAction('@videoCreatives/TOGGLE_PLAY_SOUND');
export const toggleItemSelection = createCustomAction('@videoCreatives/TOGGLE_ITEM_SELECTION', type => {
    return (id: string) => ({ id, type });
});
export const setSelection = createCustomAction('@videoCreatives/SET_SELECTION', type => {
    return (id: string) => ({ id, type });
});
export const enableEditMode = createCustomAction('@videoCreatives/TOGGLE_EDIT_MODE', type => {
    return (id: string, enabled: boolean) => ({ id, enabled, type });
});
export const nameChange = createCustomAction('@videoCreatives/NAME_CHANGE', type => {
    return (id: string, val: string) => ({ id, val, type });
});
export const saveName = createCustomAction('@videoCreatives/SAVE_NAME', type => {
    return (id: string) => ({ id, type });
});
export const saveNameSuccess = createCustomAction('@videoCreatives/SAVE_NAME_SUCCESS', type => {
    return (id: string) => ({ id, type });
});
export const resetNameToInitial = createCustomAction('@videoCreatives/RESET_NAME_TO_INITIAL', type => {
    return (id: string) => ({ id, type });
});

export type ApplyFilter = ReturnType<typeof applyFilter>;
export type LoadItems = ReturnType<typeof loadItems>;
export type SaveName = ReturnType<typeof saveName>;
export type GetCampaigns = ReturnType<typeof getCampaigns>;
export type Submit = ReturnType<typeof submit>;
export type GetPreview = ReturnType<typeof getPreview>;

export type VideoCreativesAction =
    | ApplyFilter
    | ReturnType<typeof applyFilterSuccess>
    | ReturnType<typeof loadItemsSuccess>
    | Submit
    | GetPreview
    | ReturnType<typeof openPreview>
    | ReturnType<typeof closePreview>
    | ReturnType<typeof togglePlaySound>
    | ReturnType<typeof toggleItemSelection>
    | ReturnType<typeof setSelection>
    | ReturnType<typeof enableEditMode>
    | ReturnType<typeof nameChange>
    | SaveName
    | ReturnType<typeof saveNameSuccess>
    | ReturnType<typeof resetNameToInitial>
    | GetCampaigns
    | ReturnType<typeof getCampaignsSuccess>
    | ReturnType<typeof closeCampaignsList>
    | ReturnType<typeof showError>
    | ReturnType<typeof hideError>
    | LoadItems;
